import { Directive, EmbeddedViewRef, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';
import { LDFeatureManager } from 'src/app/shared/services/ld-feature-manager';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({
    selector: '[ifLdFeature]',
    exportAs: 'ifLdFeature',
    standalone: true
})
export class IfLDFeatureDirective implements OnInit, OnDestroy {
    @Input() ifLdFeature?: FeatureFlag;
    @Input() ifLdFeatureEnabled = true;

    view!: EmbeddedViewRef<unknown>;
    constructor(
        private readonly _templateRef: TemplateRef<unknown>,
        private readonly _viewContainer: ViewContainerRef,
        private readonly _featureManager: LDFeatureManager
    ) {}

    ngOnInit() {
        if (this.ifLdFeature !== undefined) {
            this._featureManager
                .isEnabled(this.ifLdFeature)
                .pipe(untilDestroyed(this))
                .subscribe((result) => {
                    this._viewContainer.clear();
                    if ((result && this.ifLdFeatureEnabled) || (!result && !this.ifLdFeatureEnabled)) {
                        this.view = this._viewContainer.createEmbeddedView(this._templateRef);
                    }
                });
        } else {
            this.view = this._viewContainer.createEmbeddedView(this._templateRef);
        }
    }

    ngOnDestroy(): void {
        if (this.view && !this.view.destroyed) {
            this.view.destroy();
        }
    }
}
